import { useTranslation } from 'libs/i18n';
import { Typography } from 'libs/ui';
import { SettingsContent } from 'modules/administration/common/components';

import { Field } from '../../../forms/accountingSystemForm';

export const AuthorizationAndSessionSettings = () => {
  const { t } = useTranslation();
  return (
    <SettingsContent
      leftContent={
        <Typography variant="bodyBold">
          {t('administration.accountingSystem.authorizationAndSession.title')}
        </Typography>
      }
      rightContent={
        <Field.Number
          helperTextAbsolute
          showRequiredMark
          format={(v) => (!v ? '' : Number(v))}
          label={t(
            'administration.accountingSystem.authorizationAndSession.sessionLengthInDaysField.label'
          )}
          name="sessionLengthInDays"
          placeholder={t(
            'administration.accountingSystem.authorizationAndSession.sessionLengthInDaysField.placeholder'
          )}
        />
      }
    />
  );
};
